import React from 'react';

export default () => (
  <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.22222 0C11.1944 0 14.4444 2.58556 14.4444 5.77778C14.4444 8.97 11.1944 11.5556 7.22222 11.5556C6.32667 11.5556 5.46722 11.4256 4.67278 11.1944C2.56389 13 0 13 0 13C1.68278 11.3172 1.95 10.1833 1.98611 9.75C0.758333 8.71722 0 7.31611 0 5.77778C0 2.58556 3.25 0 7.22222 0ZM6.5 7.94444V9.38889H7.94444V7.94444H6.5ZM6.5 6.5H7.94444V2.16667H6.5V6.5Z" fill="currentColor" />
  </svg>
);
